// extracted by mini-css-extract-plugin
export default {"container":"DigitalCatalog_container__C0bRr","miniMenu":"DigitalCatalog_miniMenu__w3bU4","miniMenuOption":"DigitalCatalog_miniMenuOption__v2WY1"};